import { render } from "./AddCmsWidget.vue?vue&type=template&id=ec5ead2c&lang=html"
import script from "./AddCmsWidget.vue?vue&type=script&lang=js"
export * from "./AddCmsWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__